import { Injectable, NgZone, inject } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { Store } from '@ngrx/store';
import { LatestDeviceDiagnosticDto } from '@rocksoft/appmanagement-sdk';
import { AppManagementHubService } from '@rocksoft/shared';
import { LatestDeviceDiagnosticsActions } from '@era/stores';

@Injectable()
export class LatestDeviceDiagnosticsSignalR {
  private readonly zone = inject(NgZone);
  private readonly store = inject(Store);
  private readonly appManagementHubService = inject(AppManagementHubService);
  private readonly hubConnection: HubConnection;
  private initialized = false;

  constructor() {
    this.hubConnection = this.appManagementHubService.hubConnection;
    this.initialize();
  }

  initialize() {
    if (this.initialized) {
      return;
    }

    this.hubConnection.on('LatestDeviceDiagnosticUpdated', (diagnostic: LatestDeviceDiagnosticDto) => {
      this.zone.run(() => {
        this.store.dispatch(
          LatestDeviceDiagnosticsActions.LatestDeviceDiagnosticsSignalRActions.latestDeviceDiagnosticUpdated({
            diagnostic,
          })
        );
      });
    });
    this.initialized = true;
  }
}
